import { Component } from '@angular/core';

@Component({
    selector: 'nav-menu',
    template: require('./navmenu.component.html'),
    styles: [require('./navmenu.component.css')]
})
export class NavMenuComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/navmenu/navmenu.component.ts